import { render, staticRenderFns } from "./MDatatable.vue?vue&type=template&id=4a09993a"
import script from "./MDatatable.vue?vue&type=script&lang=js"
export * from "./MDatatable.vue?vue&type=script&lang=js"
import style0 from "./MDatatable.vue?vue&type=style&index=0&id=4a09993a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports